var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EDEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 30H30C27.25 30 25.025 32.25 25.025 35L25 65C25 67.75 27.25 70 30 70H70C72.75 70 75 67.75 75 65V35C75 32.25 72.75 30 70 30ZM69 40.625L51.325 51.675C50.525 52.175 49.475 52.175 48.675 51.675L31 40.625C30.7493 40.4843 30.5298 40.2942 30.3547 40.0661C30.1796 39.8381 30.0527 39.5769 29.9814 39.2984C29.9102 39.0199 29.8963 38.7298 29.9404 38.4458C29.9845 38.1617 30.0858 37.8895 30.2382 37.6458C30.3906 37.402 30.5908 37.1916 30.8268 37.0275C31.0628 36.8633 31.3297 36.7488 31.6112 36.6907C31.8928 36.6327 32.1832 36.6324 32.4649 36.6899C32.7466 36.7473 33.0137 36.8613 33.25 37.025L50 47.5L66.75 37.025C66.9863 36.8613 67.2534 36.7473 67.5351 36.6899C67.8168 36.6324 68.1072 36.6327 68.3888 36.6907C68.6703 36.7488 68.9372 36.8633 69.1732 37.0275C69.4092 37.1916 69.6094 37.402 69.7618 37.6458C69.9142 37.8895 70.0155 38.1617 70.0596 38.4458C70.1037 38.7298 70.0898 39.0199 70.0186 39.2984C69.9473 39.5769 69.8204 39.8381 69.6453 40.0661C69.4702 40.2942 69.2507 40.4843 69 40.625Z",
    fill: "#9C0BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2efd2b4102e2208bb6077b11d2305724.svg";
export { ForwardRef as ReactComponent };